import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shield-flash",
  "use": "icon-shield-flash-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-shield-flash\"><path d=\"M161.4 120.6L512 42.7l350.6 77.9a42.7 42.7 0 0 1 33.4 41.6v426.1a256 256 0 0 1-114 213L512 981.3l-270-180A256 256 0 0 1 128 588.4V162.2a42.7 42.7 0 0 1 33.4-41.6zM213.3 196.4v391.9a170.7 170.7 0 0 0 76 142L512 878.8l222.7-148.5A170.7 170.7 0 0 0 810.7 588.4V196.4L512 130.1 213.3 196.4zM554.7 426.7h128l-213.3 298.7v-213.3H341.3l213.3-298.7v213.3z\" p-id=\"3070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol